import angular from 'angular';
import constants from 'app/constants';
import {
  bcpSharedModelService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-other-resources-dialog.controller';
import template from './edit-other-resources-dialog.html';

// Validation
import assessmentOtherResourceMessagesTpl from './messages/otherResource.messages.html';
import assessmentOtherResourceEmailMessagesTpl from './messages/otherResource.email.messages.html';
import assessmentOtherResourcePhoneMessagesTpl from './messages/otherResource.phone.messages.html';
import assessmentOtherResourceWebsiteMessagesTpl from './messages/otherResource.website.messages.html';

class dialogService {
  getOptions($event, { otherResource }) {
    return {
      controller,
      controllerAs: 'editOtherResourcesDialogVM',
      locals: {
        otherResource
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editOtherResourcesDialog', [
  alerts,
  bcpSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editOtherResourcesDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put(
      'otherResource.messages.html', assessmentOtherResourceMessagesTpl
    );
    $templateCache.put('otherResource.messages.html', assessmentOtherResourceMessagesTpl);
    $templateCache.put('otherResource.email.messages.html', assessmentOtherResourceEmailMessagesTpl);
    $templateCache.put('otherResource.phone.messages.html', assessmentOtherResourcePhoneMessagesTpl);
    $templateCache.put('otherResource.website.messages.html', assessmentOtherResourceWebsiteMessagesTpl);
  })
  .name;
